/* Lemon & Line: "Add to cart" adds to the cart and keeps the shopper where they are.
   A small confirmation offers "View cart & check out" or "Keep shopping".
   The cart page stays the one place to check out from (gift message, free-shipping bar). */
(function () {
  if (window.__llAdded) return;
  window.__llAdded = 1;

  var TH = 10000; /* free U.S. shipping threshold, in cents */
  function money(c) { c = Number(c) || 0; return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function img(u) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }

  var css =
    '.lla{position:fixed;z-index:1001;right:24px;top:100px;width:360px;max-width:calc(100vw - 24px);background:#fff;color:#1C223F;border:1px solid #E1E1DA;box-shadow:0 12px 32px rgba(12,35,64,.18);padding:18px 18px 12px;box-sizing:border-box;text-align:left;font-size:14.5px;line-height:1.4}' +
    '.lla[hidden]{display:none}.lla:focus{outline:none}' +
    '.lla-hd{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:0 0 12px}' +
    '.lla-t{margin:0;font-weight:700;font-size:15px;display:flex;align-items:center;gap:8px}.lla-t svg{width:18px;height:18px;flex:0 0 auto}' +
    '.lla-x{background:none;border:0;padding:0 2px;font-size:26px;line-height:1;cursor:pointer;color:#1C223F}' +
    '.lla-item{display:flex;gap:12px;align-items:center;margin:0 0 12px}.lla-item img{width:64px;height:64px;object-fit:contain;background:#F0F0EC;flex:0 0 auto}' +
    '.lla-item p{margin:0}.lla-n{font-weight:600}.lla-v,.lla-p{font-size:13.5px;color:#4A5A70}' +
    '.lla-ship{margin:0 0 12px;padding:10px 12px;background:#F0F0EC;font-size:13.5px}.lla-ship:empty{display:none}' +
    '.lla-go{display:flex;align-items:center;justify-content:center;min-height:50px;background:#FA7268;color:#fff!important;font-weight:700;letter-spacing:.12em;font-size:13.5px;text-decoration:none!important;text-transform:uppercase}.lla-go:hover{background:#E9625A}' +
    '.lla-keep{display:block;margin:8px auto 0;background:none;border:0;padding:6px;font:inherit;font-size:14px;text-decoration:underline;text-underline-offset:3px;cursor:pointer;color:#1C223F}' +
    '@media (max-width:768px){.lla{left:12px;right:12px;top:auto;bottom:12px;width:auto;max-width:none}}';

  var box = null, last = null;

  function ensure() {
    if (box) return box;
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    box = document.createElement('div');
    box.className = 'lla'; box.hidden = true; box.tabIndex = -1;
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'false'); box.setAttribute('aria-labelledby', 'lla-t');
    box.innerHTML =
      '<div class="lla-hd"><p class="lla-t" id="lla-t"><svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="#1C223F"/><path d="M5.5 10.5l3 3 6-6.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Added to your cart</p>' +
      '<button type="button" class="lla-x" aria-label="Close">&times;</button></div>' +
      '<div class="lla-item"></div><p class="lla-ship"></p>' +
      '<a class="lla-go" href="/cart">View cart &amp; check out</a>' +
      '<button type="button" class="lla-keep">Keep shopping</button>';
    document.body.appendChild(box);
    box.addEventListener('click', function (e) { if (e.target.closest('.lla-x,.lla-keep')) hide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box && !box.hidden) hide(); });
    document.addEventListener('click', function (e) {
      if (!box || box.hidden || box.contains(e.target)) return;
      if (e.target.closest('form[action*="/cart/add"],.llc-add')) return;
      hide();
    });
    return box;
  }

  function hide() {
    if (!box) return;
    box.hidden = true;
    if (last && last.focus) { try { last.focus({ preventScroll: true }); } catch (e) {} }
  }

  function show(it) {
    var b = ensure();
    last = document.activeElement;
    var v = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
    var price = it.final_price != null ? it.final_price : it.price;
    b.querySelector('.lla-item').innerHTML =
      (it.image ? '<img src="' + esc(img(it.image)) + '" alt="" width="64" height="64">' : '') +
      '<div><p class="lla-n">' + esc(it.product_title || it.title) + '</p>' +
      (v ? '<p class="lla-v">' + esc(v) + '</p>' : '') +
      '<p class="lla-p">' + money(price) + '</p></div>';
    var s = b.querySelector('.lla-ship');
    s.textContent = '';
    b.hidden = false;
    try { b.focus({ preventScroll: true }); } catch (e) {}
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var left = TH - c.total_price;
        s.innerHTML = left > 0
          ? 'You&rsquo;re <b>' + money(left) + '</b> away from free U.S. shipping.'
          : 'You&rsquo;ve earned <b>free U.S. shipping</b>.';
      })
      .catch(function () {});
  }

  /* Other add-to-cart buttons on the site (ll-ctl.js product rows) call this after adding */
  window.llShowAdded = function (d) {
    var it = d && d.items ? d.items[0] : d;
    if (it) show(it);
  };

  /* Product page "Add to cart": add without leaving the page */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    if ((f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    var host = f.closest('block-buy-buttons');
    if (!host || !window.fetch || !window.FormData) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = f.querySelector('[name="add"]');
    if (btn) {
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('btn--loading');
    }
    var old = f.querySelector('.errors');
    if (old) old.remove();

    var fd = new FormData(f);
    fd.set('sections', 'cart-ajax');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        /* updates the cart count in the header */
        try { host.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: j, preventCartOpen: true } })); } catch (err) {}
        window.llShowAdded(j);
      })
      .catch(function (err) {
        var msg = err && ((typeof err.description === 'string' && err.description) || err.message);
        if (msg) {
          var d = document.createElement('div');
          d.className = 'errors text-center';
          d.textContent = msg;
          f.appendChild(d);
        } else {
          /* network trouble: fall back to the normal add-to-cart (goes to the cart page) */
          HTMLFormElement.prototype.submit.call(f);
        }
      })
      .then(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('btn--loading'); }
      });
  }, true);
})();
